import React from 'react';
import DefaultMailMenuConfig from './DefaultMailMenuConfig';
import { FLOLDER, MAIL_MENU_ITEM } from '../../../constant';
import { apiHolder as api } from 'api';
import { findAndMergeDefaultMenuConfig, getShowByFolder, proxyTaskMailClick } from '../util';
import { getIn18Text } from 'api';
import { getMailFromMails } from '@web-mail/util';
import IconCard from '@web-common/components/UI/IconCard';
const eventApi = api.api.getEventApi();
const systemApi = api.api.getSystemApi();
const ReadMailIconMenuThreadConfig = [
    {
        key: MAIL_MENU_ITEM.BACK,
        icon: React.createElement(IconCard, { type: "arrowDown", stroke: "#3C3F47" }),
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY,
        icon: undefined,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ALL,
        icon: undefined,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.REPLAY_ALL_AS_NEW,
        icon: undefined,
        group: '1',
    },
    {
        key: MAIL_MENU_ITEM.FORWARD,
        icon: undefined,
        group: '1',
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.FORWARD,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.DELIVERY,
                icon: undefined,
                show: (mails, defaultShow) => {
                    var _a;
                    const mail = getMailFromMails(mails);
                    if (!(process.env.BUILD_ISEDM || ((_a = systemApi === null || systemApi === void 0 ? void 0 : systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion))) {
                        return !!defaultShow && defaultShow(mail);
                    }
                    return false;
                },
                onClick: (mails, defaultClickFn) => {
                    const mail = getMailFromMails(mails);
                    const { entry: { id, threadMessageFirstId }, _account, isThread, } = mail;
                    let mailId = id;
                    if (isThread) {
                        mailId = threadMessageFirstId;
                    }
                    eventApi.sendSysEvent({
                        eventName: 'mailMenuOper',
                        eventData: {
                            mailId,
                            account: _account,
                            way: 'mailTop',
                        },
                        eventStrData: 'delivery',
                    });
                    defaultClickFn && defaultClickFn(mail);
                },
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.MARK,
        icon: undefined,
        group: '1',
        name: getIn18Text('BIAOJI'),
        onlyUnfold: true,
        show: mails => {
            const mail = getMailFromMails(mails);
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.RED_FLAG,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.READ,
                icon: undefined,
            },
            {
                key: MAIL_MENU_ITEM.TAG,
                icon: undefined,
            },
        ], DefaultMailMenuConfig),
    },
    {
        key: MAIL_MENU_ITEM.MOVE,
        icon: undefined,
        group: '1',
        onClick: proxyTaskMailClick,
    },
    {
        key: MAIL_MENU_ITEM.TOP,
        icon: undefined,
        group: '1',
        onClick: proxyTaskMailClick,
    },
    {
        key: MAIL_MENU_ITEM.DELETE,
        icon: undefined,
        group: '1',
        onClick: proxyTaskMailClick,
    },
    {
        key: 'more',
        icon: undefined,
        group: '1',
        name: getIn18Text('GENGDUO'),
        onlyUnfold: true,
        show: mails => {
            const mail = getMailFromMails(mails);
            return !getShowByFolder(mail, [FLOLDER.DRAFT]);
        },
        subMenus: findAndMergeDefaultMenuConfig([
            {
                key: MAIL_MENU_ITEM.SEARCH_IN_CONTENT,
                icon: undefined,
                group: '1',
            },
            {
                key: MAIL_MENU_ITEM.OPEN_IN_WINDOW,
                icon: undefined,
                group: '2',
            },
            {
                key: MAIL_MENU_ITEM.EXPORT,
                icon: undefined,
                group: '2',
            },
        ], DefaultMailMenuConfig),
    },
];
export default findAndMergeDefaultMenuConfig(ReadMailIconMenuThreadConfig, DefaultMailMenuConfig);
